import { OrderDirection } from '@wix/media-platform-js-client/dist/mjs/src/types/media-platform/media-platform';
import { MaybeUndef } from '../../types/system';
import { Action } from '../redux.types';

import {
  SortActionPayload,
  SORTED_COLUMNS_ACTIONS,
} from './sorted-columns.actions';

export { OrderDirection as SortDirection };

export interface TableSorting {
  columnName: string;
  direction: MaybeUndef<OrderDirection>;
}

export interface SortedColumns {
  [tableName: string]: TableSorting;
}

const defaultState = {};

export const sortedColumns = (
  state: SortedColumns = defaultState,
  { type, payload }: Action,
) => {
  switch (type) {
    case SORTED_COLUMNS_ACTIONS.SORT:
      const typedPayload: SortActionPayload = payload;
      return {
        ...state,
        [typedPayload.tableName]: {
          columnName: typedPayload.columnName,
          direction: typedPayload.direction,
        },
      };

    default:
      return state;
  }
};
